<template>
  <div class="fb-board">
    <div class="d-flex flex-wrap mb-3">
      <button type="button" class="fb-board__chip" :class="{ 'fb-board__chip--on': !status }" @click="status = ''">
        全部(전체) <b>{{ rows.length }}</b>
      </button>
      <button v-for="s in STATUSES" :key="s.key" type="button" class="fb-board__chip" :class="['fb-board__chip--' + s.key, { 'fb-board__chip--on': status === s.key }]" @click="status = status === s.key ? '' : s.key">
        {{ s.zh }}({{ s.ko }}) <b>{{ count(s.key) }}</b>
      </button>
    </div>
    <div class="d-flex flex-wrap align-items-center mb-3">
      <input v-model.trim="keyword" type="text" class="form-control form-control-sm fb-board__search mr-2" placeholder="搜索(검색)">
      <select v-model="status" class="form-control form-control-sm fb-board__sel mr-2">
        <option value="">全部状态(상태 전체)</option>
        <option v-for="s in STATUSES" :key="s.key" :value="s.key">{{ s.zh }}({{ s.ko }})</option>
      </select>
      <button class="btn btn-sm btn-outline-secondary" type="button" :disabled="loading" @click="load">刷新(새로고침)</button>
    </div>
    <p v-if="error" class="text-danger">{{ error }}</p>
    <div class="table-responsive">
      <table class="table table-sm fb-board__table">
        <thead>
          <tr>
            <th>#</th>
            <th>请求时间(요청시각)</th>
            <th>请求人(요청자)</th>
            <th>内容(내용)</th>
            <th>状态(상태)</th>
            <th>等待对象(대기 대상)</th>
            <th>预计日期(예상일자)</th>
            <th>实际上线日(실제 반영일)</th>
            <th>备注(비고)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in shown" :key="r._id" :class="r.status === 'done' ? 'fb-board__row--done' : 'fb-board__row--open'">
            <td class="text-muted">{{ r.no }}</td>
            <td class="text-nowrap">{{ day(r.requestedAt) }} {{ r.requestedTime || '' }}</td>
            <td class="text-nowrap">{{ r.requestedBy || '-' }}</td>
            <td>
              <div class="fb-board__title">{{ r.title_zh }}</div>
              <div class="small text-muted">{{ r.title_ko }}</div>
            </td>
            <td class="text-nowrap"><span class="badge" :class="'fb-board__badge--' + r.status">{{ label(r.status) }}</span></td>
            <td class="text-nowrap">{{ waiting(r.waitingOn) }}</td>
            <td class="text-nowrap">
              <template v-if="r.status !== 'done'">{{ r.etaDate ? day(r.etaDate) : '未定(미정)' }}</template>
            </td>
            <td class="text-nowrap">
              <template v-if="r.status === 'done'">{{ r.shippedAt ? day(r.shippedAt) : '-' }}</template>
            </td>
            <td class="small">{{ r.note_zh }}<span v-if="r.note_ko" class="text-muted">({{ r.note_ko }})</span></td>
          </tr>
          <tr v-if="!shown.length">
            <td colspan="9" class="text-muted small">{{ loaded ? '暂无(없음)' : '' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="text-muted small">只有真正可以使用时才会显示「已完成」(「已完成」는 실제로 쓸 수 있을 때만 표시됩니다). 预计日期可能调整，没有依据时显示「未定」(예상일자는 바뀔 수 있고, 근거가 없으면 «미정»으로 표시됩니다).</p>
  </div>
</template>

<script>
import axios from 'axios';

const STATUSES = [
  { key: 'done', zh: '已完成', ko: '완료' },
  { key: 'doing', zh: '进行中', ko: '진행' },
  { key: 'waiting', zh: '等待确认', ko: '대기' },
  { key: 'todo', zh: '未开始', ko: '미착수' },
  { key: 'unknown', zh: '待确认结果', ko: '확인 못함' }
];
const WAITING = { YZY: 'YZY', 崔凡: '崔凡', owner: '老板(사장님)' };

export default {
  name: 'CoupassFeedbackBoard',
  data() {
    return { STATUSES, rows: [], keyword: '', status: '', loading: false, loaded: false, error: '' };
  },
  computed: {
    shown() {
      const k = this.keyword.toLowerCase();
      return this.rows.filter(r => (!this.status || r.status === this.status)
        && (!k || ((r.title_zh || '') + ' ' + (r.title_ko || '') + ' ' + (r.requestedBy || '') + ' ' + (r.note_zh || '') + ' ' + (r.note_ko || '')).toLowerCase().includes(k)));
    }
  },
  mounted() { this.load(); },
  methods: {
    count(key) { return this.rows.filter(r => r.status === key).length; },
    label(key) {
      const s = STATUSES.find(x => x.key === key);
      return s ? `${s.zh}(${s.ko})` : '';
    },
    waiting(key) { return key ? (WAITING[key] || key) : ''; },
    day(v) { return v ? String(v).slice(0, 10) : ''; },
    async load() {
      this.loading = true; this.error = '';
      try {
        const res = await axios.post('/api/coupass-feedback/list', {});
        if (res.data['요청결과'] === '성공') this.rows = res.data.rows || [];
        else this.error = '加载失败(불러오기 실패)';
      } catch (e) {
        console.error('coupass-feedback/list', e);
        this.error = '加载失败(불러오기 실패)';
      } finally { this.loading = false; this.loaded = true; }
    }
  }
};
</script>

<style scoped>
.fb-board__search { max-width: 220px; }
.fb-board__sel { max-width: 180px; }
.fb-board__chip { border: 1px solid #ced4da; background: #fff; border-radius: 16px; padding: 3px 12px; margin: 0 6px 6px 0; font-size: 13px; }
.fb-board__chip--on { background: #343a40; border-color: #343a40; color: #fff; }
.fb-board__chip--done { border-color: #28a745; }
.fb-board__chip--doing { border-color: #007bff; }
.fb-board__chip--waiting { border-color: #fd7e14; }
.fb-board__chip--todo { border-color: #6c757d; }
.fb-board__chip--unknown { border-color: #dc3545; }
.fb-board__table th { white-space: nowrap; background: #f6f7f9; }
.fb-board__title { font-weight: 600; }
.fb-board__row--done { background: #f0faf2; }
.fb-board__row--open { background: #fff8ec; }
.fb-board__badge--done { background: #28a745; color: #fff; }
.fb-board__badge--doing { background: #007bff; color: #fff; }
.fb-board__badge--waiting { background: #fd7e14; color: #fff; }
.fb-board__badge--todo { background: #6c757d; color: #fff; }
.fb-board__badge--unknown { background: #dc3545; color: #fff; }
</style>
